// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { ArrowIcon, CloseFullCircleIcon } from '@/icons';
import { StyledButtonsWrap } from '../Styled';
import { StyledButton, StyledCheckmarkCircleIcon, StyledStatusButton } from './UsersTableActionsStyles';

// Models
import { IUserProfile } from '@/models/users.model';

type TUsersTableActions = {
  setCurrentUserDetails: (user: IUserProfile) => void;
  authAsUser: (id: string) => void;
  record: IUserProfile;
};

const UsersTableActions = ({ record, setCurrentUserDetails, authAsUser }: TUsersTableActions) => {
  const { t } = useTranslation(['usersList']);
  const isActive = record.active;
  const userStatusButtonText = isActive ? 'users_list_block_button' : 'users_list_unblock_button';

  const handleClick = () => setCurrentUserDetails(record);
  const handleAuthAsUser = () => record.id && authAsUser(record.id);

  return (
    <StyledButtonsWrap>
      <StyledStatusButton type={isActive ? 'text' : 'default'} onClick={handleClick}>
        {isActive ? <CloseFullCircleIcon /> : <StyledCheckmarkCircleIcon />}
        {t(userStatusButtonText)}
      </StyledStatusButton>
      <StyledButton onClick={handleAuthAsUser}>
        <ArrowIcon />
        {t('users_list_enter_button')}
      </StyledButton>
    </StyledButtonsWrap>
  );
};

export default UsersTableActions;
